export default "__VITE_ASSET__a715d471__"